import React, { ReactElement } from 'react';
import { Location, NavigateFunction, Params, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Programme } from '../../../../types/entity.types';
import { RootState } from '../../../../types/state/root.types';

import { getClassNames } from '../../../../utils/util';
import { GENERAL, PLAN, ACCOUNTABILITY, SUPPORT, TRIBE, NEW } from '../../../../utils/constants';

import './programme-navbar.scss';

const SECTIONS: string[] = [GENERAL, PLAN, ACCOUNTABILITY, SUPPORT, TRIBE];

type Props = {
  onNavigate?: (value: string) => void;
};

const ProgrammeNavbar = ({ onNavigate }: Props): ReactElement => {
  const location: Location = useLocation();

  const navigate: NavigateFunction = useNavigate();

  const programme: Programme | undefined = useSelector(
    ({ programme }: RootState): Programme | undefined => programme.programme
  );

  const { status, programmeExternalReference }: Params = useParams();

  const showIcon = (text: string): boolean => {
    if (!programme || text === GENERAL || status === NEW) return false;

    const { planExternalReference, accountabilityExists, supportExternalReference, tribeExternalReference } = programme;

    if (text === PLAN && planExternalReference) return false;

    if (text === ACCOUNTABILITY && accountabilityExists) return false;

    if (text === SUPPORT && supportExternalReference) return false;

    if (text === TRIBE && tribeExternalReference) return false;

    return true;
  };

  const handleButtonClick = (text: string): void => {
    if (status === NEW || location.pathname.includes(text)) return;

    let url: string = `/programmes/${status}/${programmeExternalReference}/${text}`;
    if (text === GENERAL || text === ACCOUNTABILITY) {
      url = `${url}/members`;
    }

    if (onNavigate) {
      onNavigate(url);
    } else {
      navigate(url);
    }
  };

  const renderNavItems = (): ReactElement[] => {
    return SECTIONS.map(
      (text: string): ReactElement => (
        <div
          className={getClassNames('programme-navbar__button', {
            active: location.pathname.includes(text) || (location.pathname.includes('new') && text === GENERAL)
          })}
          onClick={(): void => handleButtonClick(text)}
          key={text}
          data-testid={text}
        >
          <span>{text.toUpperCase()[0]}</span>
          <span>{text.toUpperCase().slice(1)}</span>
          {showIcon(text) && (
            <div className="programme-navbar__icon" data-testid={`${text}-icon`}>
              <p>!</p>
            </div>
          )}
        </div>
      )
    );
  };

  return <div className="programme-navbar">{renderNavItems()}</div>;
};

export default ProgrammeNavbar;
